import { Route, Routes } from "react-router-dom"
import List from "./view/List"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  )
}
